// extracted by mini-css-extract-plugin
module.exports = {"userName":"DayReportTableRow_userName__AhMfe","userDayToggle":"DayReportTableRow_userDayToggle__3SycZ"};